import { createContext } from 'react-router'

/**
 * `true` only when a loader is invoked by `usePreloadRoute`, which calls loaders
 * directly to warm caches while the reader is still on the previous page. Such a
 * call is not a navigation, so loaders must skip anything with a side effect the
 * reader would notice — redirects above all, since react-router would throw the
 * returned `Response` out of a call it never initiated.
 *
 * Reading it never throws: the context carries `false` as its default, so
 * loaders reached through a real navigation see `false` without the router
 * having to set anything.
 */
export const fromPreloadRouteContext = createContext(false)
